import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints, CurrencyPackageNewsListItemKeys, CurrencyPackagesResponseKeys, CurrencyPackageItemKeys } from '../Constants';
import RequestHelper from '../RequestHelper';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import buyItem from './buyItem';
import buyItemWithBillingProfile from './buyItemWithBillingProfile';
import TimeStampManager from '../../utils/TimestampManager';
import store from '../../state/store';
import { setActiveConsumables } from '../../state/actions/consumables';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { fetchGameRooms } from '../../state/query/games/utils';
import ERROR_CODE from '../../utils/errorCodes';
/** @typedef {import('../Constants').CurrencyPackagesResponse} CurrencyPackagesResponse */

/** @typedef {import('../Constants').PackageListInfo} PackageListInfo */

export default {
  /**
   * @returns {Promise<import("../Constants").BillingProfiles>}
   * @throws Response error
   */
  getBillingProfiles: function () {
    var _getBillingProfiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_BILLING_PROFILES
              });

            case 3:
              response = _context.sent['0'];

              if (response.billingProfiles !== undefined) {
                response.billingProfiles = transformObjectArrayResponse(response.billingProfiles);
              }

              return _context.abrupt("return", response);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.GET_BILLING_PROFILES_ERROR
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    function getBillingProfiles() {
      return _getBillingProfiles.apply(this, arguments);
    }

    return getBillingProfiles;
  }(),
  getAddressForPurchase: function () {
    var _getAddressForPurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_PURCHASE_ADDRESS
              });

            case 3:
              response = _context2.sent['0'];
              return _context2.abrupt("return", response);

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
                code: ERROR_CODE.GET_ADDRESS_FOR_PURCHASE_ERROR
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    function getAddressForPurchase() {
      return _getAddressForPurchase.apply(this, arguments);
    }

    return getAddressForPurchase;
  }(),

  /**
   * Gets the available currency packages for the user.
   * @async
   * @returns {Promise<import('./Constants').CurrencyPackagesResponse>} The available currency packages for the user.
   * @throws Response error
   */
  getCurrencyPackages: function () {
    var _getCurrencyPackages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var promoValue,
          endpoint,
          params,
          response,
          transformed,
          i,
          packageType,
          packageListInfo,
          eventPayload,
          _i,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              promoValue = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;

              if (promoValue) {
                endpoint = "".concat(Endpoints.GET_CURRENCY_PACKAGES).concat(promoValue);
              } else {
                endpoint = Endpoints.GET_CURRENCY_PACKAGES;
              }

              _context3.prev = 2;
              params = {
                endpoint: endpoint,
                logJSON: true
              };
              _context3.next = 6;
              return RequestHelper.apiGet(params, true);

            case 6:
              response = _context3.sent;
              // Remap the response keys

              /** @type {CurrencyPackagesResponse} */
              transformed = transformObjectResponseKeys(response, CurrencyPackagesResponseKeys); // Make news list a real array

              transformed.NEWS_LIST = transformObjectArrayResponse(transformed.NEWS_LIST); // Remap the keys to be real names

              for (i = 0; i < transformed.NEWS_LIST.length; i++) {
                transformed.NEWS_LIST[i] = transformObjectResponseKeys(transformed.NEWS_LIST[i], CurrencyPackageNewsListItemKeys);
              } // Only need to transform coins


              packageType = 'coins';
              /** @type {PackageListInfo} */

              packageListInfo = transformed.PACKAGE_LIST[packageType]; // Transform objectArray into real array

              packageListInfo.items = transformObjectArrayResponse(packageListInfo.items);

              if (packageListInfo.items.length == 0) {
                eventPayload = {
                  description: 'No currency packages returned from server',
                  code: 'C01'
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              } // Remap the keys to be real names


              for (_i = 0; _i < packageListInfo.items.length; _i++) {
                packageListInfo.items[_i] = transformObjectResponseKeys(packageListInfo.items[_i], CurrencyPackageItemKeys);
              }

              transformed.PACKAGE_LIST.vip_room_access.items = transformObjectArrayResponse(transformed.PACKAGE_LIST.vip_room_access.items);
              console.log("------ packages received from bbe back end: ".concat(transformed.PACKAGE_LIST));
              return _context3.abrupt("return", transformed);

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3["catch"](2);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
                code: ERROR_CODE.GET_CURRENCY_PACKAGES_ERROR
              });

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 20]]);
    }));

    function getCurrencyPackages() {
      return _getCurrencyPackages.apply(this, arguments);
    }

    return getCurrencyPackages;
  }(),
  buyItem: buyItem,
  buyItemWithBillingProfile: buyItemWithBillingProfile,
  removeBillingProfile: function () {
    var _removeBillingProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(pid) {
      var response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.REMOVE_BILLING_PROFILE,
                body: {
                  profile: pid
                }
              }, true);

            case 3:
              response = _context4.sent;
              _context4.next = 9;
              break;

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                pid: pid,
                error: JSON.stringify(_context4.t0, Object.getOwnPropertyNames(_context4.t0)),
                code: ERROR_CODE.REMOVE_BILLING_PROFILE_ERROR
              });

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 6]]);
    }));

    function removeBillingProfile(_x) {
      return _removeBillingProfile.apply(this, arguments);
    }

    return removeBillingProfile;
  }(),
  finishWebPurchase: function () {
    var _finishWebPurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
      var response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.FINISH_WEB_PURCHASE,
                body: args,
                logJSON: true
              });

            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response && response['0'] ? response['0'] : null);

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context5.t0, Object.getOwnPropertyNames(_context5.t0)),
                code: ERROR_CODE.FINISH_WEB_PURCHASE_ERROR
              });

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 7]]);
    }));

    function finishWebPurchase(_x2) {
      return _finishWebPurchase.apply(this, arguments);
    }

    return finishWebPurchase;
  }(),

  /**
   * Check promo code.
   * @param {String} code Promo code.
   * @param {String} promotype Promotion type. One of ["purchase", "signup", "lobby"]
   * @param {Number} [currencysku] Required if promotype === "purchase", otherwise undefined. The SKU of the currency purchase.
   */
  checkPromoCode: function () {
    var _checkPromoCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(code, promotype, currencysku) {
      var response;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.CHECK_PROMO_CODE,
                body: _objectSpread({
                  promocode: code,
                  promotype: promotype
                }, function () {
                  if (promotype === 'purchase') {
                    return {
                      ci_id: currencysku
                    };
                  }

                  return {};
                }())
              }, true);

            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", response);

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                body: {
                  promoCode: code,
                  promotype: promotype,
                  currencysku: currencysku
                },
                error: JSON.stringify(_context6.t0, Object.getOwnPropertyNames(_context6.t0)),
                code: ERROR_CODE.CHECK_PROMO_CODE_ERROR
              });

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 7]]);
    }));

    function checkPromoCode(_x3, _x4, _x5) {
      return _checkPromoCode.apply(this, arguments);
    }

    return checkPromoCode;
  }(),

  /**
   * Purchase with casino dollars.
   * @param {String} ptype Purchase type. One of ["currency", "task", "restore"]
   * @param {Number} currpkgid Currency package ID.
   * @param {Number} saleId Dynamic Sale ID when purchase is made through a Dynamic Triggered Sale.
   */
  purchaseWithCasinoDollars: function () {
    var _purchaseWithCasinoDollars = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ptype, currpkgid) {
      var saleId,
          messageId,
          active_game_id,
          trigger_id,
          response,
          _args7 = arguments;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              saleId = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 0;
              messageId = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
              active_game_id = _args7.length > 4 ? _args7[4] : undefined;
              trigger_id = _args7.length > 5 ? _args7[5] : undefined;
              _context7.prev = 4;
              _context7.next = 7;
              return RequestHelper.apiPost({
                endpoint: Endpoints.PURCHASE_WITH_CASINO_DOLLARS,
                body: {
                  ptype: ptype,
                  currpkgid: currpkgid,
                  saleId: saleId,
                  messageId: messageId,
                  active_game_id: active_game_id,
                  trigger_id: trigger_id
                }
              }, false);

            case 7:
              response = _context7.sent;
              fetchGameRooms(true);
              return _context7.abrupt("return", response);

            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](4);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                body: {
                  ptype: ptype,
                  currpkgid: currpkgid,
                  saleId: saleId,
                  messageId: messageId,
                  active_game_id: active_game_id,
                  trigger_id: trigger_id
                },
                error: JSON.stringify(_context7.t0, Object.getOwnPropertyNames(_context7.t0)),
                code: ERROR_CODE.PURCHASE_WITH_CASINO_DOLLARS_ERROR
              });

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[4, 12]]);
    }));

    function purchaseWithCasinoDollars(_x6, _x7) {
      return _purchaseWithCasinoDollars.apply(this, arguments);
    }

    return purchaseWithCasinoDollars;
  }(),

  /** @typedef {import("../Constants").DTS} DTS */
  DTSCallbackId: -1,

  /**
   * Refresh DTS state in the store.
   * @param {DTS} existingDTS Used for if initApp already had a DTS.
   * @async
   */
  refreshDTS: function () {
    var _refreshDTS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(existingDTS) {
      var _this = this;

      var usingDTS, response, timeToNextCall;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;

              /** @type {DTS} */
              usingDTS = null;

              if (existingDTS) {
                _context8.next = 9;
                break;
              }

              _context8.next = 5;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_DYNAMIC_SALE
              }, true);

            case 5:
              response = _context8.sent;
              usingDTS = response[0];
              _context8.next = 10;
              break;

            case 9:
              usingDTS = existingDTS;

            case 10:
              // Update the store
              // store.dispatch(setDtsState(usingDTS));
              // If we previously registered and we've called this method sooner than the expiry,
              // clear it. Unregister safely handles the call if it's already been removed and no-ops.
              TimeStampManager.unregister(this.DTSCallbackId);
              timeToNextCall = (usingDTS ? usingDTS.timeRemaining : 10 * 60) * 1000; // Call itself when DTS expires
              // If no DTS, check again in 10 minutes

              this.DTSCallbackId = TimeStampManager.register(timeToNextCall, function () {
                return _this.refreshDTS();
              });
              _context8.next = 18;
              break;

            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                existingDTS: existingDTS,
                error: JSON.stringify(_context8.t0, Object.getOwnPropertyNames(_context8.t0)),
                code: ERROR_CODE.REFRESH_DTS_ERROR
              });

            case 18:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[0, 15]]);
    }));

    function refreshDTS(_x8) {
      return _refreshDTS.apply(this, arguments);
    }

    return refreshDTS;
  }(),
  ActiveConsumablesCallbackId: -1,
  refreshActiveConsumables: function () {
    var _refreshActiveConsumables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var activeConsumables;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_ACTIVE_CONSUMABLES,
                ignoreCache: true
              }, true);

            case 3:
              activeConsumables = _context9.sent;
              // Update the store
              store.dispatch(setActiveConsumables(activeConsumables)); // Update the store

              _context9.next = 10;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context9.t0, Object.getOwnPropertyNames(_context9.t0)),
                code: ERROR_CODE.REFRESH_ACTIVE_CONSUMABLES_ERROR
              });

            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 7]]);
    }));

    function refreshActiveConsumables() {
      return _refreshActiveConsumables.apply(this, arguments);
    }

    return refreshActiveConsumables;
  }(),
  claimFreeConsumable: function () {
    var _claimFreeConsumable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(item_id, item_type) {
      var claimResponse;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.CLAIM_FREE_CONSUMABLE,
                body: {
                  item_id: item_id,
                  item_type: item_type
                }
              }, true);

            case 3:
              claimResponse = _context10.sent;
              return _context10.abrupt("return", claimResponse);

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                body: {
                  itemId: item_id,
                  itemType: item_type
                },
                error: JSON.stringify(_context10.t0, Object.getOwnPropertyNames(_context10.t0)),
                code: ERROR_CODE.CLAIM_FREE_CONSUMABLE_ERROR
              });

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[0, 7]]);
    }));

    function claimFreeConsumable(_x9, _x10) {
      return _claimFreeConsumable.apply(this, arguments);
    }

    return claimFreeConsumable;
  }()
};